/*
 * Um post embutido dentro de outro: as
 * respostas que se abrem abaixo de um post, ou o post respondido que se abre
 * acima dele. O conteúdo é o HTML já renderizado pelo servidor; quando o post
 * veio só como relação (sem o HTML), quem embute busca antes de mostrar.
 */
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
import Icon from 'flarum/common/components/Icon';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import username from 'flarum/common/helpers/username';
import classList from 'flarum/common/utils/classList';
import { fullDate, shortAge } from '../../utils/dates';
import { t } from '../../utils/settings';
import { userIcons } from '../../utils/userIcons';
export default class EmbeddedPost extends Component {
  view() {
    const post = this.attrs.post;
    const user = post.user();
    const html = post.contentHtml();
    const time = post.createdAt();
    return m("article", {
      className: classList('CanelaEmbeddedPost', this.attrs.className),
      "data-number": post.number()
    }, m("div", {
      className: "CanelaEmbeddedPost-side"
    }, m(Avatar, {
      user: user || null
    })), m("div", {
      className: "CanelaEmbeddedPost-main"
    }, m("header", {
      className: "CanelaEmbeddedPost-header"
    }, m("span", {
      className: "CanelaEmbeddedPost-name"
    }, username(user || null)), userIcons(user || null, 'embedded'), m(Link, {
      className: "CanelaEmbeddedPost-link",
      href: app.route.post(post),
      title: t('topic.embedded.go_to_post')
    }, time ? m("time", {
      dateTime: time.toISOString(),
      title: fullDate(time)
    }, shortAge(time)) : null, m(Icon, {
      name: this.attrs.direction === 'up' ? 'fas fa-arrow-up' : 'fas fa-arrow-down'
    }))), m("div", {
      className: "CanelaEmbeddedPost-body"
    }, html ? m.trust(html) : m("p", null, post.contentPlain() || ''))));
  }
}

/** Busca, numa requisição só, os posts que vieram sem o HTML. */
export function loadMissingContent(posts) {
  const missing = posts.filter(post => !post.contentHtml()).map(post => post.id());
  if (!missing.length) return Promise.resolve();
  return app.store.find('posts', {
    filter: {
      id: missing.join(',')
    }
  }, undefined, {
    errorHandler: () => {}
  });
}
export function embeddedLoading() {
  return m(LoadingIndicator, {
    size: "small",
    display: "block",
    className: "CanelaEmbeddedPost-loading"
  });
}
flarum.reg.add('ramon-canela', 'forum/topic/components/EmbeddedPost', EmbeddedPost);